export default __webpack_public_path__ + "static/media/assetTradeIcon1.33391ab8.webp";